// https://github.com/rudderlabs/rudder-sdk-js/blob/3a818accd24e6b3667c75a6b60fb12aba36bdf7e/packages/analytics-js/LICENSE
// MIT License
/**
 * A function to validate current session and return true/false depending on that
 * @returns boolean
 */
export var hasSessionExpired = function (expiresAt) {
    var timestamp = Date.now();
    return Boolean(timestamp > expiresAt);
};
var generateSessionId = function () { return Date.now(); };
export var isManualSessionIdValid = function (sessionId) {
    if (!sessionId ||
        sessionId.toString().startsWith('-') ||
        sessionId.toString().length < 10) {
        return false;
    }
    return true;
};
var MIN_SESSION_TIMEOUT_MS = 10 * 1000; // 10 seconds
var DEFAULT_SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
/**
 * A function to generate new auto tracking session
 * @param sessionTimeout current timestamp
 * @returns SessionInfo
 */
export var generateAutoTrackingSession = function (sessionTimeout) {
    var timestamp = Date.now();
    var timeout = sessionTimeout || DEFAULT_SESSION_TIMEOUT_MS;
    if (timeout < MIN_SESSION_TIMEOUT_MS) {
        console.warn('Session timeouts of less than 10 seconds are not recommended');
    }
    return {
        id: timestamp,
        expiresAt: timestamp + timeout,
        timeout: timeout,
        sessionStart: true,
        autoTrack: true,
    };
};
/**
 * A function to generate new manual tracking session
 * @param id Provided sessionId
 * @returns SessionInfo
 */
export var generateManualTrackingSession = function (id) {
    var sessionId = isManualSessionIdValid(id)
        ? id
        : generateSessionId();
    return {
        id: sessionId,
        sessionStart: true,
        manualTrack: true,
    };
};
export var updateSessionExpiration = function (session) {
    session.sessionStart = false;
    if (session.autoTrack) {
        // extend session by `timeout`
        session.expiresAt = Date.now() + session.timeout;
    }
    return session;
};
//# sourceMappingURL=index.js.map